<template>
  <div class="min-h-screen flex flex-col items-center justify-center gap-6 px-4">
    <div class="flex flex-col items-center gap-2">
      <img src="/eqsys-white.svg" alt="eqSys" class="h-12 w-auto" />
    </div>

    <div class="max-w-md w-full p-6 shadow-lg card">
      <h2 class="text-xl font-semibold mb-1 text-[color:var(--color-text)]">{{ $t('ui.additionalVerificationRequired') }}</h2>
      <p class="text-sm mb-5 text-[color:var(--color-muted)]">
        {{ $t('ui.stepUpRequirement', { tenant: tenantSlug ?? '', aal: requiredAal }) }}
      </p>

      <div v-if="methods.length === 0" class="state-empty">
        {{ $t('ui.noAuthenticationMethodsAvailablePleaseContactYourAdministrator') }}
      </div>

      <div v-else class="space-y-3">
        <button
          v-for="m in methods"
          :key="m.provider_id"
          class="btn primary w-full"
          :disabled="redirecting"
          @click="startOidc(m.provider_id)"
        >
          {{ $t('login.signInWith', { provider: m.name }) }}
        </button>
      </div>

      <div v-if="error" class="text-sm text-red-400 mt-4">{{ error }}</div>

      <div class="mt-6 pt-4 border-t border-[color:var(--color-border)]">
        <button class="btn ghost text-sm" @click="router.replace('/')">{{ $t('common.cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()
import { useI18n } from 'vue-i18n'

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'

const router = useRouter()
const authStore = useAuthStore()

const redirecting = ref(false)
const error = ref(null)

// Pull step-up info from the auth store (set by apiClient response interceptor)
const stepUp = computed(() => authStore.pendingStepUp)
const tenantSlug = computed(() => stepUp.value?.tenant_slug)
const requiredAal = computed(() => stepUp.value?.required_aal ?? 2)
const methods = computed(() => stepUp.value?.methods ?? [])

onMounted(() => {
  if (!stepUp.value) {
    // Navigated here directly without a pending step-up — go home
    router.replace('/')
  }
})

async function startOidc(providerId) {
  error.value = null
  redirecting.value = true
  try {
    await authStore.loginWithOIDC(tenantSlug.value, providerId)
    // loginWithOIDC redirects window.location.href — execution stops here
  } catch (e) {
    error.value = e.data?.error || t('ui.failedToStartSignInPleaseTryAgain')
    redirecting.value = false
  }
}
</script>
